module.exports = __webpack_public_path__ + "img/registered.0509c582.png";